// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1Wk3C","rightSidebar":"styles__rightSidebar___2FcWQ","closeIcon":"styles__closeIcon___T_RfI"};